'use client'

import React, { useEffect, useState } from 'react'

import type { SectionBlock as BlockProps } from '@/payload-types'
import { RenderBlocks, type Block } from '@/blocks/RenderBlocks'
import { createClientLogger } from '@/lib/logger/client'

const log = createClientLogger('SectionBlock')

export const SectionBlock: React.FC<BlockProps> = ({ section }) => {
  const [blocks, setBlocks] = useState<Block[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function fetchSection() {
      try {
        const response = await fetch(`/api/sections/by-slug/${section}`)
        if (!response.ok) {
          log.error('Failed to fetch section')
          setLoading(false)
          return
        }
        const data = await response.json()
        setBlocks((data.blocks ?? []) as Block[])
      } catch (error) {
        log.error({ error }, 'Error fetching section:')
      } finally {
        setLoading(false)
      }
    }

    fetchSection()
  }, [section])

  if (loading) return null
  if (!blocks.length) return null

  return <RenderBlocks blocks={blocks} />
}
